import Vue from 'vue'
import Router from 'vue-router'
import Company from '@/views/company'
import Home from '@/views/home'
 
Vue.use(Router);
 
export default new Router({
  mode: 'history',
  routes: [
		{
			 path: '/',
			   component: Home,
		}
  ]
})